import { MdKeyboardArrowLeft } from 'react-icons/md';
import styles from './toolCard.module.scss';
import { Link } from 'react-router-dom';
import { __ToolCardPropsType } from './toolCard.type';
import { AppLinkComp } from 'components';

const ToolsCardComp = (props: __ToolCardPropsType) => {
    const Content = () => (
        <div
            className={`${styles['tools-card-layout']} center-content-y flex-between p-1 pointer ${props.className ?? ''}`}
            onClick={props.onClick}
        >
            <div className={`${styles['title']} center-content-y g-1`}>
                {props.icon} <p className="t-400 t-p2 t-l-black1">{props.title}</p>
            </div>
            {props.noAction ? (
                <p className="t-400 t-p2 t-l-gray1">{props.text}</p>
            ) : (
                <MdKeyboardArrowLeft size={16} className="t-black1 t-d-gray1" />
            )}
        </div>
    );

    return props.href ? (
        props.navigate ? (
            <a target="_blank" href={props.href}>
                <Content />
            </a>
        ) : props.nextLink ? (
            <AppLinkComp href={props.href}>
                <Content />
            </AppLinkComp>
        ) : (
            <Link to={props.href}>
                <Content />
            </Link>
        )
    ) : (
        <Content />
    );
};

export default ToolsCardComp;
